<template>
  <div class="brb-root" :style="themePageStyle">
    <head>
      <meta charset="utf-8" /><title>FLOCKR | Buy Requests</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <link rel="shortcut icon" href="/assets/images/favicon.svg">
      <link href="/assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <link href="/assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <link href="/assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <link href="/assets/css/custom.css" rel="stylesheet" type="text/css" />
    </head>
    <body :data-sidebar="darkMode ? 'dark' : 'light'">
    <div id="layout-wrapper">
      <nav class="brb-topbar">
        <div class="container d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center" style="gap:16px;">
            <back-button class="me-2" />
            <a href="javascript:void(0)" @click="$router.push('/')"><img src="/assets/images/flockr_logo.png" alt="Flockr" style="height:34px;" /></a>
            <span class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:15px;">Buy Requests</span>
          </div>
          <div class="d-flex gap-2">
            <button class="btn btn-sm btn-outline-secondary" @click="$router.push('/my-buy-requests')"><i class="mdi mdi-format-list-bulleted me-1"></i>My Requests</button>
            <button class="btn btn-sm btn-warning" @click="$router.push('/marketplace/buy-requests/create')"><i class="mdi mdi-plus me-1"></i>Post Request</button>
          </div>
        </div>
      </nav>

      <div class="container brb-container">
        <!-- intro -->
        <div class="brb-intro">
          <div class="brb-intro-body">
            <div class="brb-intro-title">📣 Buyers are looking for livestock</div>
            <div class="brb-intro-sub">Butcheries, farmers and traders post what they want to buy. See a match? Respond with your offer.</div>
          </div>
          <button class="brb-intro-btn" @click="$router.push('/marketplace/buy-requests/create')"><i class="mdi mdi-plus me-1"></i>Post a request</button>
        </div>

        <!-- search -->
        <div class="brb-searchbar">
          <i class="mdi mdi-magnify"></i>
          <input v-model="keyword" placeholder="Search buy requests…" @keyup.enter="search" />
          <select v-model="speciesId" class="brb-sp" @change="search">
            <option value="">All species</option>
            <option v-for="sp in speciesList" :key="sp.id" :value="sp.id">{{ sp.name }}</option>
          </select>
        </div>

        <div v-if="loading" class="text-center py-5"><div class="spinner-border text-warning"></div></div>

        <div v-else-if="requests.length === 0" class="brb-empty">
          <i class="mdi mdi-bullhorn-outline"></i>
          <h5>No active buy requests</h5>
          <p>Be the first to post what you're looking for!</p>
          <button class="btn btn-warning mt-2" @click="$router.push('/marketplace/buy-requests/create')"><i class="mdi mdi-plus me-1"></i>Post buy request</button>
        </div>

        <div v-else class="brb-feed">
          <div v-for="(br, bi) in requests" :key="'br-'+bi" class="brb-post" @click="$router.push('/marketplace/buy-requests/'+br.id)">
            <div class="brb-post-head">
              <user-avatar :src="br.buyer_avatar" :name="br.buyer_name" size="md" :style="br.buyer_id ? 'cursor:pointer' : ''" @click.stop="goBuyer(br)" />
              <div class="brb-post-hb">
                <div class="brb-post-author" :style="br.buyer_id ? 'cursor:pointer' : ''" @click.stop="goBuyer(br)">
                  {{ br.buyer_name || 'A buyer' }}
                  <span v-if="br.buyer_rating" class="brb-rate"><i class="mdi mdi-star"></i> {{ Number(br.buyer_rating).toFixed(1) }}</span>
                </div>
                <div class="brb-post-meta">
                  <span>{{ relTime(br.created_at) }}</span><i class="mdi mdi-earth"></i>
                  <span v-if="br.location_label" class="brb-loc"><i class="mdi mdi-map-marker"></i>{{ br.location_label }}</span>
                </div>
              </div>
              <span class="brb-status" :class="{talks: br.lock_status==='locked'}">{{ br.lock_status==='locked' ? 'In talks' : 'Open' }}</span>
            </div>

            <div class="brb-want">Looking for <strong>{{ br.title }}</strong></div>
            <div class="brb-chips">
              <span class="brb-tag"><i class="mdi mdi-paw"></i> {{ br.species_name }}</span>
              <span v-if="br.breed_name" class="brb-tag">{{ br.breed_name }}</span>
              <span class="brb-tag"><i class="mdi mdi-package-variant"></i> {{ br.quantity_needed }} needed</span>
              <span v-if="br.sex_preference && br.sex_preference !== 'any'" class="brb-tag">{{ br.sex_preference }}</span>
            </div>
            <div v-if="br.budget_min || br.budget_max" class="brb-budget">
              Budget: {{ (br.currency || 'KES') }} {{ formatPrice(br.budget_min) }} – {{ formatPrice(br.budget_max) }} <span class="brb-budget-type">({{ br.price_type }})</span>
            </div>
            <div v-if="br.description" class="brb-desc">{{ br.description }}</div>

            <div class="brb-foot">
              <div class="brb-foot-meta">
                <span><i class="mdi mdi-account-voice"></i> {{ br.response_count || 0 }} response{{ Number(br.response_count)===1 ? '' : 's' }}</span>
                <span v-if="br.needed_by"><i class="mdi mdi-clock-outline"></i> by {{ formatDate(br.needed_by) }}</span>
              </div>
              <button class="brb-respond" @click.stop="$router.push('/marketplace/buy-requests/'+br.id)"><i class="mdi mdi-hand-coin-outline"></i> Respond</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </body>
  </div>
</template>
<style>

/* === GLOBAL THEME === */
html[data-theme="light"] body { background:#FFFFFF!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-card,html[data-theme="light"] .p2c,html[data-theme="light"] .ld-section,html[data-theme="light"] .ld-action-card,html[data-theme="light"] .ld-seller-card,html[data-theme="light"] .ld-info-card,html[data-theme="light"] .ld-related-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-overlay .fm-modal,html[data-theme="light"] .ad-overlay .ad-modal { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-input,html[data-theme="light"] .fm-select { background:#F7F5F2!important; border-color:#E0D8D0!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-label { color:#555!important; }
html[data-theme="dark"] body { background:#0A0A0A!important; color:#F5F0E8!important; }
</style>
<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] body{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .card{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .card-body{color:#1A1A1A!important}
html[data-theme="light"] .modal-content{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#1A1A1A!important}
html[data-theme="light"] .form-control,html[data-theme="light"] .form-select{background:#FFFFFF!important;border-color:#E0D8D0!important;color:#1A1A1A!important}
html[data-theme="light"] .table{color:#1A1A1A!important}
html[data-theme="light"] .table th{color:#555!important;border-color:#E8E2DA!important}
html[data-theme="light"] .table td{border-color:#F0EBE4!important}
html[data-theme="light"] [style*="color:#F5F0E8"]{color:#1A1A1A!important}
html[data-theme="light"] [style*="color:#6B6356"]{color:#777!important}
html[data-theme="light"] [style*="color:#A09888"]{color:#555!important}
html[data-theme="light"] [style*="background:#0F0F0F"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#141414"]{background:#FFFFFF!important}
html[data-theme="light"] [style*="background:#1E1E1E"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="background:#0A0A0A"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#1a1510"]{background:#FFF8F0!important}
html[data-theme="light"] [style*="background:#1A1A1A"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="border:1px solid #1E1E1E"]{border-color:#E8E2DA!important}
html[data-theme="light"] [style*="border:1px solid #2A2520"]{border-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1A1A1A"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1E1E1E"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #2A2520"]{border-bottom-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-top:1px solid #2A2520"]{border-top-color:#E0D8D0!important}
html[data-theme="light"] [style*="color:#BFA164"]{color:#BFA164!important}
html[data-theme="light"] [style*="color:#50C878"]{color:#50C878!important}
html[data-theme="light"] [style*="color:#4FC3F7"]{color:#4FC3F7!important}
html[data-theme="light"] [style*="color:#FF6B6B"]{color:#FF6B6B!important}
html[data-theme="light"] [style*="color:#FF9800"]{color:#FF9800!important}
html[data-theme="light"] [style*="color:#CE93D8"]{color:#CE93D8!important}
</style>

<style>
:root{
  --fm-h:#F5F0E8;
  --fm-s:#6B6356;
  --fm-m:#A09888;
  --fm-bg1:#141414;
  --fm-bg2:#0F0F0F;
  --fm-bg3:#1E1E1E;
  --fm-br:#1E1E1E;
  --fm-page:#0A0A0A;
}

html[data-theme="light"]{
  --fm-h:#1A1A1A;
  --fm-s:#777777;
  --fm-m:#555555;
  --fm-bg1:#FFFFFF;
  --fm-bg2:#F7F5F2;
  --fm-bg3:#F0EBE4;
  --fm-br:#E8E2DA;
  --fm-page:#F7F5F2;
}

html[data-theme="light"] body,
html[data-theme="light"] #layout-wrapper,
html[data-theme="light"] .brb-root,
html[data-theme="light"] .brb-container{
  background:var(--fm-page)!important;
  color:var(--fm-h)!important;
}

html[data-theme="dark"] body,
html[data-theme="dark"] #layout-wrapper,
html[data-theme="dark"] .brb-root,
html[data-theme="dark"] .brb-container{
  background:var(--fm-page)!important;
  color:var(--fm-h)!important;
}

html[data-theme="light"] .brb-topbar{
  background:#FFFFFF!important;
  border-bottom-color:#E8E2DA!important;
}
html[data-theme="dark"] .brb-topbar{
  background:var(--fm-bg1,#141414)!important;
}

html[data-theme="light"] .brb-search-card,
html[data-theme="light"] .brb-card,
html[data-theme="light"] .brb-empty-card{
  background:#FFFFFF!important;
  border-color:#E8E2DA!important;
  color:#1A1A1A!important;
}
html[data-theme="light"] .brb-intro{background:linear-gradient(120deg,#f4ead0,#fbf7ee)!important;border-color:#BFA164!important}
html[data-theme="light"] .brb-intro-title{color:#1A1A1A!important}
html[data-theme="light"] .brb-intro-sub{color:#7a6a45!important}
html[data-theme="light"] .brb-post,
html[data-theme="light"] .brb-searchbar,
html[data-theme="light"] .brb-empty{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .brb-want,
html[data-theme="light"] .brb-post-author{color:#1A1A1A!important}

html[data-theme="light"] .brb-title,
html[data-theme="light"] .brb-card-title,
html[data-theme="light"] .brb-budget,
html[data-theme="light"] .brb-section-title{
  color:#1A1A1A!important;
}

html[data-theme="light"] .brb-meta,
html[data-theme="light"] .brb-submeta,
html[data-theme="light"] .brb-empty-subtext,
html[data-theme="light"] .brb-muted{
  color:#555!important;
}

html[data-theme="light"] .brb-input,
html[data-theme="light"] .brb-select,
html[data-theme="light"] input,
html[data-theme="light"] select{
  background:#FFFFFF!important;
  color:#1A1A1A!important;
  border-color:#E0D8D0!important;
}

html[data-theme="light"] input::placeholder{
  color:#777!important;
}
</style>

<style scoped>
.brb-root{background:var(--fm-bg2,#0F0F0F)!important;min-height:100vh}
.brb-topbar{position:sticky;top:0;z-index:100;padding:12px 0;background:rgba(10,10,10,.95)!important;backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.brb-container{padding-top:80px;padding-bottom:60px;max-width:640px}
.brb-intro{display:flex;align-items:center;gap:14px;background:linear-gradient(120deg,#3a2f17,#1a1207);border:1px solid #BFA164;border-radius:14px;padding:16px 18px;margin-bottom:14px}
.brb-intro-body{flex:1;min-width:0}
.brb-intro-title{color:#F5F0E8;font-weight:800;font-size:16px}
.brb-intro-sub{color:#D8CDB6;font-size:12.5px;margin-top:2px}
.brb-intro-btn{background:#BFA164;border:none;color:#0A0A0A;font-weight:700;font-size:13px;padding:9px 14px;border-radius:9px;white-space:nowrap;flex-shrink:0}
.brb-searchbar{display:flex;align-items:center;gap:8px;background:var(--fm-bg1,#141414)!important;border:1px solid var(--fm-br,#1E1E1E);border-radius:22px;padding:8px 14px;margin-bottom:16px}
.brb-searchbar i{color:var(--fm-s,#6B6356);font-size:18px}
.brb-searchbar input{flex:1;background:transparent;border:none;outline:none;color:var(--fm-h,#F5F0E8);font-size:14px}
.brb-sp{background:transparent;border:none;outline:none;color:var(--fm-m,#A09888);font-size:13px;max-width:130px}
.brb-empty{text-align:center;padding:50px 20px;background:var(--fm-bg1,#141414)!important;border:1px solid var(--fm-br,#1E1E1E);border-radius:14px}
.brb-empty i{font-size:60px;color:var(--fm-s,#3A3530)}
.brb-empty h5{color:var(--fm-h,#F5F0E8);margin-top:12px}
.brb-empty p{color:var(--fm-s,#6B6356);font-size:14px}
.brb-feed{display:flex;flex-direction:column;gap:14px}
.brb-post{background:var(--fm-bg1,#141414)!important;border:1px solid var(--fm-br,#1E1E1E);border-radius:14px;padding:14px;cursor:pointer;transition:border-color .15s,transform .15s}
.brb-post:hover{border-color:#BFA164;transform:translateY(-1px)}
.brb-post-head{display:flex;align-items:flex-start;gap:10px;margin-bottom:8px}
.brb-post-hb{flex:1;min-width:0}
.brb-post-author{color:var(--fm-h,#F5F0E8);font-weight:700;font-size:14px;display:flex;align-items:center;gap:6px;flex-wrap:wrap}
.brb-rate{color:#f1b44c;font-size:11px;font-weight:600}
.brb-post-meta{display:flex;align-items:center;gap:5px;color:var(--fm-s,#6B6356);font-size:12px;margin-top:1px}
.brb-post-meta i{font-size:13px}
.brb-loc{display:inline-flex;align-items:center;gap:2px;color:#66BB6A}
.brb-status{background:rgba(80,200,120,.14);color:#50C878;font-size:10px;font-weight:800;letter-spacing:.4px;padding:3px 9px;border-radius:8px;flex-shrink:0;text-transform:uppercase}
.brb-status.talks{background:rgba(241,180,76,.16);color:#f1b44c}
.brb-want{color:var(--fm-h,#F5F0E8);font-size:15px;line-height:1.4;margin-bottom:8px}
.brb-want strong{color:#BFA164}
.brb-chips{display:flex;flex-wrap:wrap;gap:6px;margin-bottom:8px}
.brb-budget{color:#BFA164;font-weight:700;font-size:14px;margin-bottom:6px}
.brb-budget-type{font-weight:400;color:var(--fm-s,#6B6356);font-size:11px}
.brb-desc{color:var(--fm-m,#A09888);font-size:13px;line-height:1.5;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}
.brb-foot{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-top:12px;padding-top:10px;border-top:1px solid var(--fm-br,#1E1E1E)}
.brb-foot-meta{display:flex;gap:14px;color:var(--fm-s,#6B6356);font-size:12px}
.brb-foot-meta i{font-size:13px}
.brb-respond{background:#BFA164;border:none;color:#0A0A0A;font-weight:700;font-size:13px;padding:8px 16px;border-radius:8px;display:flex;align-items:center;gap:5px;flex-shrink:0}
.brb-respond:hover{background:#d4b96e}
.brb-filters{background:var(--fm-bg1,#141414)!important;border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:16px}
.brb-input{background:var(--fm-bg2,#0F0F0F)!important;border:1px solid var(--fm-br,#2A2520);color:var(--fm-h,#F5F0E8)!important;border-radius:8px}
.brb-input:focus{border-color:#BFA164;box-shadow:0 0 0 2px rgba(191,161,100,.15);background:var(--fm-bg2,#0F0F0F)!important;color:var(--fm-h,#F5F0E8)!important}
.brb-input option{background:var(--fm-bg1,#141414)!important;color:var(--fm-h,#F5F0E8)!important}
.brb-card{background:var(--fm-bg1,#141414)!important;border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:16px;cursor:pointer;transition:all .2s;height:100%}
.brb-card:hover{border-color:#BFA164;transform:translateY(-2px)}
.brb-avatar{width:36px;height:36px;border-radius:50%;background:var(--fm-bg3,#1E1E1E)!important;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;color:#BFA164!important;flex-shrink:0}
.brb-tag{padding:2px 8px;border-radius:10px;font-size:10px;background:rgba(191,161,100,.08)!important;color:#BFA164!important;border:1px solid var(--fm-br,#2A2520)}

/* ===== MOBILE — feels-like-an-app ===== */
@media (max-width: 768px) {
  .brb-container { padding-top: 70px !important; padding-bottom: calc(80px + env(safe-area-inset-bottom, 0px)) !important; padding-left: 12px !important; padding-right: 12px !important; }
  .brb-card { padding: 12px; border-radius: 10px; }
  .brb-input { font-size: 16px !important; padding: 9px 11px !important; }
  .brb-avatar { width: 32px; height: 32px; }
  .brb-tag { font-size: 9px; padding: 2px 6px; }
}
</style>
<script>
import { executeJson, flocker } from "@/api";
import UserAvatar from "@/components/flockr-users/UserAvatar.vue";
export default {
  name: "BuyRequestsBoard",
  components: { UserAvatar },
  data(){return{
    darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
    themeObserver:null,
    loading:true,requests:[],speciesList:[],keyword:'',speciesId:''}},
  mounted(){
    // Apply global theme
    var t=localStorage.getItem('flockr_theme')||'dark';window.__flockrSetTheme(t);
    this.fetchSpecies();this.search()},
  beforeUnmount: function() {
    if (this.themeObserver) this.themeObserver.disconnect();
  },
  computed:{
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'},
    themeCardStyle(){return this.darkMode?'background:#141414!important;border:1px solid #1E1E1E!important;':'background:#FFFFFF!important;border:1px solid #E8E2DA!important;'},
    themeInputStyle(){return this.darkMode?'background:#0F0F0F;border:1px solid #2A2520;color:#F5F0E8;':'background:#FFFFFF;border:1px solid #E0D8D0;color:#1A1A1A;'},
  },
  methods:{
    async fetchSpecies(){try{var r=await executeJson({function:"getAnimalSpecies"},flocker);if(r.data.success)this.speciesList=r.data.data.species||[]}catch(e){console.error(e)}},
    async search(){
      this.loading=true;
      var params={function:"getBuyRequests"};
      if(this.keyword)params.keyword=this.keyword;
      if(this.speciesId)params.speciesId=this.speciesId;
      try{var r=await executeJson(params,flocker);if(r.data.success)this.requests=r.data.data.buyRequests||[]}catch(e){console.error(e)}
      this.loading=false
    },
    formatPrice(a){return a?Number(a).toLocaleString('en-KE'):'0'},
    formatDate(d){if(!d)return'';return new Date(d).toLocaleDateString('en-KE',{day:'numeric',month:'short',year:'numeric'})},
    getInitials(n){if(!n)return'?';return n.split(' ').map(function(w){return w[0]}).join('').substring(0,2).toUpperCase()},
    relTime(ts){ if(!ts) return ''; var diff=Math.floor((Date.now()-new Date(String(ts).replace(' ','T')).getTime())/1000); if(diff<60)return'just now'; if(diff<3600)return Math.floor(diff/60)+'m'; if(diff<86400)return Math.floor(diff/3600)+'h'; if(diff<2592000)return Math.floor(diff/86400)+'d'; return String(ts).split(' ')[0].split('T')[0]; },
    goBuyer(br){ if(br && br.buyer_id) this.$router.push('/u/'+br.buyer_id); }
  }
};
</script>
